// contact us
import './index.less'
import './tree-select.less'

import { verifyEmail } from '@utils/index.js'
import { shopCR, contactMediaSubmit, contactMediaUpload, getCategory, getProductName, zendeskUpload, zendeskSubmit } from '@utils/api.js'

import TreeSelect from "./tree-select.js"

class ContactUs {
  constructor(el) {

    this.DOM = { el };
    const $container = $('.contact-us-form');
    this.successMessage = $container.data('success-message');
    this.errorMessage = $container.data('error-message');

    this.init()
  }
  init() {
    this.switchTab()
    this.mediaInit()
    this.customerInit()
  }
  mediaInit() {
    this.submit()
    this.focus()
    this.upload()
  }
  customerInit() {
    this.getCategoryData()
    this.getProductData()
    this.customerUpload()
    this.customerSubmit()
    this.customerFocus()
  }
  switchTab() {
    $('.J-contact-tabs span').click(function () {
      const index = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      $('.J-contact-form >div').eq(index).addClass('active').siblings().removeClass('active')
    })
  }
  getCategoryData() {
    let params = {
      // fieldId: '7586589783311'
      // // fieldId: '17948055445787'
    }
    getCategory(params).then(res => {
      let data = res.data || []
      if (data) {
        // let str = '<option value="" style="display:none;"></option>'
        // data.map(item => {
        //   str += `
        //     <option value="${item.value}" data-id="${item.id}">${item.name}</option>
        //   `
        // })
        // $('#Contact_Customer_Category').append(str)
        this.cateSelect = new TreeSelect({
          data,
          el: document.querySelector(".category_field")
        })
      }
    })
      .catch(err => {
        console.log(err);
      })
  }
  getProductData() {
    let params = {
      // fieldId: '5845813794575'
      // fieldId: '7492361159707'
    }
    getProductName(params).then(res => {
      let data = res.data || []
      if (data) {
        this.TreeSelect = new TreeSelect({
          data,
          el: document.querySelector(".contact-us__tree_field")
        })
        // let str = '<option value="" style="display:none;"></option>'
        // data.map(item => {
        //   str += `
        //     <option value="${item.value}" data-id="${item.id}">${item.name}</option>
        //   `
        // })
        // $('#Contact_Customer_Product').append(str)
      }
    })
      .catch(err => {
        console.log(err);
      })
  }
  customerUpload() {
    let _self = this;
    $('#Contact_Customer_Attachment').change(function (e) {
      const file = e.target.files[0];
      let size = _self.formatSize(file.size);
      if (file) {
        if ((file.size / 1048576).toFixed(2) > 10) {
          pushErrorMessage(shopCR === 'DE'
            ? 'Die hochgeladene Datei ist größer als 10 MB.  Bitte versuchen Sie es noch einmal.'
            : "The file you uploaded has exceeded 10MB, please upload it again.")
          e.target.value = ''
          return false;
        }
        $('.J-contact-customer-submit').addClass('btn--loading')
        $('#Contact_Customer_Attachment').parent('.btn').hide()
        let formData = new FormData();
        formData.append("file", file);
        zendeskUpload(formData).then(res => {
          _self.showCustomerFile(res.data, size)
          $('.J-contact-customer-submit').removeClass('btn--loading')
          e.target.value = ''
        })
          .catch(err => {
            $('.J-contact-customer-submit').removeClass('btn--loading')
            $('#Contact_Customer_Attachment').parent('.btn').show()
            e.target.value = ''
          })
      }
    })
  }
  showCustomerFile(data, size) {
    let str = `
    <div class="item" data-token="${data.token}">
      <i class="iconfont jackery-icon-lianjie link-icon"></i>
      <span class="name">${data.fileName}</span>
      <span class="size">${size}</span>
      <i class="iconfont jackery-icon-a- delete-icon"></i>
    </div>
    `

    $('.J-contact-customer-filelist').append(str).show()
    this.delCustomerFile()
    if ($('.J-contact-customer-filelist').children().length >= 3) {
      $('#Contact_Customer_Attachment').parent('.btn').hide()
    } else {
      $('#Contact_Customer_Attachment').parent('.btn').show()
    }
  }
  delCustomerFile() {
    $('.J-contact-customer-filelist .iconfont').click(function () {
      $(this).parent('.item').remove()
      $('#Contact_Customer_Attachment').parent('.btn').show()
      if ($('.J-contact-customer-filelist').children().length == 0) {
        $('.J-contact-customer-filelist').hide()
      }
    })
  }
  customerSubmit() {
    let _self = this;
    $('.J-contact-customer-submit').click(function () {
      if (_self.checkCustomerForm()) {
        // categoryId, productId是获取下拉数据接口请求传的ID，说是第三方系统传参的时候要这个值，ID是IT那边给的，有问题可以咨询IT那边的张磊
        let customerData = {
          // categoryId: $('#Contact_Customer_Category option:selected').data('id'),
          // categoryValue: $('#Contact_Customer_Category').val(),
          categoryValue: $('.category_field .z-tree-input').attr("data-value"),

          email: $('#Contact_Customer_Email').val(),
          message: $('#Contact_Customer_Message').val(),
          name: $('#Contact_Customer_Name').val(),
          // productId: $('#Contact_Customer_Product option:selected').data('id'),
          // productValue: $('#Contact_Customer_Product').val(),
          productValue: $('.contact-us__tree_field .z-tree-input').attr("data-value"),
        }
        let fileList = []
        if ($('.J-contact-customer-filelist').children().length > 0) {
          $('.J-contact-customer-filelist').children().each(function () {
            fileList.push($(this).attr('data-token'))
          })
        }
        customerData.attachTokenList = fileList
        let params = {
          country: shopCR == 'GB' ? 'UK' : shopCR,
          ...customerData
        }
        $('.J-contact-customer-submit').addClass('btn--loading')
        zendeskSubmit(params).then(res => {
          pushSuccessMessage(_self.successMessage || (shopCR === 'DE'
            ? 'Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns so schnell wie möglich bei Ihnen.'
            : "Your message has been successfully sent. we'll get back to you as soon as possible"))
          _self.resetCustomerFormData()
          $('.J-contact-customer-submit').removeClass('btn--loading')
        })
          .catch(err => {
            if (err.status == 50006) {
              pushErrorMessage(_self.errorMessage || (shopCR === 'DE'
                ? 'Hoppla! Etwas ist schiefgelaufen! Probieren Sie es auf eine andere Weise!'
                : "Woops! Something wrong! Try another way!"))
            }
            $('.J-contact-customer-submit').removeClass('btn--loading')
          })
      } else {
        let top = $('.J-customer-support .red').first().offset().top
        if (top) {
          $('html, body').animate({ scrollTop: top - 150 }, 'slow');
        }
      }
    })
  }
  checkCustomerForm() {
    let checkStatus = true
    if (!$("#agree:checked").val()) {
      $('#error-agree').show()
      checkStatus = false
    }

    if (!$('#Contact_Customer_Email').val() || !verifyEmail($('#Contact_Customer_Email').val())) {
      $('#Contact_Customer_Email').addClass('red')
      checkStatus = false
    }
    if (!$('#Contact_Customer_Name').val()) {
      $('#Contact_Customer_Name').addClass('red')
      checkStatus = false
    }
    // if (!$('#Contact_Customer_Category').val()) {
    //   $('#Contact_Customer_Category').addClass('red')
    //   checkStatus = false
    // }
    if (!document.querySelector(".category_field .z-tree-input").value) {
      document.querySelector(".category_field").classList.add("red")
      checkStatus = false
    }

    if (!$('#Contact_Customer_Message').val()) {
      $('#Contact_Customer_Message').addClass('red')
      checkStatus = false
    }
    return checkStatus
  }
  resetCustomerFormData() {
    $('#Contact_Customer_Email').val('')
    $('#Contact_Customer_Name').val('')
    // $('#Contact_Customer_Category').val('')
    // $('#Contact_Customer_Product').val('')
    this.TreeSelect && this.TreeSelect.handleReset()
    this.cateSelect && this.cateSelect.handleReset()

    $('#Contact_Customer_Message').val('')
    $('.J-contact-customer-filelist').children().remove()
    $('.J-contact-customer-filelist').hide()
    $('#Contact_Customer_Attachment').parent('.btn').show()
    $('#agree').prop('checked', false)
    $('#error-agree').addClass('hidden')
  }
  customerFocus() {
    $('#agree').change(function () {
      // 检查是否有单选按钮被选中
      if ($(this).is(':checked')) {
        // 如果有单选按钮被选中，则显示p标签
        $('#error-agree').hide();
      } else {
        // 如果没有单选按钮被选中，则隐藏p标签
        $('#error-agree').show();
      }
    });

    $('.J-customer-support input').focus(function () {
      $(this).removeClass('red')
    })
    $('.J-customer-support select').focus(function () {
      $(this).removeClass('red')
    })
    $('.J-customer-support textarea').focus(function () {
      $(this).removeClass('red')
    })

  }
  submit() {
    let _self = this;
    $('.J-contact-submit').click(function () {
      if (_self.checkMediaForm()) {
        let mediaCooperation = {
          name: $('#Contact_Media_Name').val(),
          email: $('#Contact_Media_Email').val(),
          category: $('#Contact_Media_Category').val(),
          plantform: $('#Contact_Media_Plantform').val(),
          audlence: $('#Contact_Media_Audience').val(),
          influence: $('#Contact_Media_Influence').val(),
          introduction: $('#Contact_Media_Introduction').val(),
          partnership: $('#Contact_Media_Proposal').val()
        }
        let fileList = []
        if ($('.J-contact-flie-list').children().length > 0) {
          $('.J-contact-flie-list').children().each(function () {
            fileList.push({
              fileUrl: $(this).attr('data-fileUrl'),
              originalFilename: $(this).attr('data-originalFilename')
            })
          })
        }
        mediaCooperation.attachments = fileList
        let params = {
          cr: shopCR,
          ...mediaCooperation
        }
        $('.J-contact-submit').addClass('btn--loading')
        contactMediaSubmit(params).then(res => {
          pushSuccessMessage(_self.successMessage || (shopCR === 'DE'
            ? 'Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns so schnell wie möglich bei Ihnen.'
            : "Your message has been successfully sent. we'll get back to you as soon as possible"))
          _self.resetFormData()
          $('.J-contact-submit').removeClass('btn--loading')
        })
          .catch(err => {
            if (err.status != 500) {
              pushErrorMessage(_self.errorMessage || (shopCR === 'DE'
                ? 'Hoppla! Etwas ist schiefgelaufen! Probieren Sie es auf eine andere Weise!'
                : "Woops! Something wrong! Try another way!"))
            }
            $('.J-contact-submit').removeClass('btn--loading')
          })
      } else {
        let top = $('.J-media-cooperation .red').first().offset().top
        if (top) {
          $('html, body').animate({ scrollTop: top - 150 }, 'slow');
        }
      }
    })
  }
  focus() {
    $('#agree-media').change(function () {
      // 检查是否有单选按钮被选中
      if ($(this).is(':checked')) {
        // 如果有单选按钮被选中，则显示p标签
        $('#error-agree-media').hide();
      } else {
        // 如果没有单选按钮被选中，则隐藏p标签
        $('#error-agree-media').show();
      }
    });

    $('.J-media-cooperation input').focus(function () {
      $(this).removeClass('red')
    })
  }
  // 校验
  checkMediaForm() {
    let checkStatus = true
    if (!$("#agree-media:checked").val()) {
      $('#error-agree-media').show()
      checkStatus = false
    }
    if (!$('#Contact_Media_Name').val()) {
      $('#Contact_Media_Name').addClass('red')
      checkStatus = false
    }
    if (!$('#Contact_Media_Email').val() || !verifyEmail($('#Contact_Media_Email').val())) {
      $('#Contact_Media_Email').addClass('red')
      checkStatus = false
    }
    if (!$('#Contact_Media_Category').val()) {
      $('#Contact_Media_Category').addClass('red')
      checkStatus = false
    }
    if (!$('#Contact_Media_Plantform').val()) {
      $('#Contact_Media_Plantform').addClass('red')
      checkStatus = false
    }
    if (!$('#Contact_Media_Audience').val()) {
      $('#Contact_Media_Audience').addClass('red')
      checkStatus = false
    }
    if (!$('#Contact_Media_Influence').val()) {
      $('#Contact_Media_Influence').addClass('red')
      checkStatus = false
    }
    return checkStatus
  }
  // 重置表单数据
  resetFormData() {
    $('#Contact_Media_Name').val('')
    $('#Contact_Media_Email').val('')
    $('#Contact_Media_Category').val('')
    $('#Contact_Media_Plantform').val('')
    $('#Contact_Media_Audience').val('')
    $('#Contact_Media_Influence').val('')
    $('#Contact_Media_Introduction').val('')
    $('#Contact_Media_Proposal').val('')
    $('.J-contact-flie-list').children().remove()
    $('.J-contact-flie-list').hide()
    $('#Contact_Media_Proposalt').parent('.btn').show()
    $('#agree-media').prop('checked', false)
    $('#error-agree-media').addClass('hidden')
  }
  // 上传
  upload() {
    let _self = this;
    $('#Contact_Media_Proposalt').change(function (e) {
      const file = e.target.files[0];
      let size = _self.formatSize(file.size);
      if (file) {
        if ((file.size / 1048576).toFixed(2) > 10) {
          pushErrorMessage(shopCR === 'DE'
            ? 'Die hochgeladene Datei ist größer als 10 MB.  Bitte versuchen Sie es noch einmal.'
            : "The file you uploaded has exceeded 10MB, please upload it again.")
          e.target.value = ''
          return false;
        }
        $('.J-contact-submit').addClass('btn--loading')
        $('#Contact_Media_Proposalt').parent('.btn').hide()
        let formData = new FormData();
        formData.append("file", file);
        contactMediaUpload(formData).then(res => {
          _self.showFile(res.data, size)
          $('.J-contact-submit').removeClass('btn--loading')
          e.target.value = ''
        })
          .catch(err => {
            $('.J-contact-submit').removeClass('btn--loading')
            $('#Contact_Media_Proposalt').parent('.btn').show()
            e.target.value = ''
            if (err.code == 10011) {
              pushErrorMessage(err.message)
            }
          })
      }
    })
  }
  // 格式化文件大小
  formatSize(size) {
    if (size < 1024) {
      return size + " B";
    } else if (size < 1048576) {
      return (size / 1024).toFixed(2) + " KB";
    } else if (size < 1073741824) {
      return (size / 1048576).toFixed(2) + " MB";
    } else {
      return (size / 1073741824).toFixed(2) + " GB";
    }
  }
  // 显示上传后的文件
  showFile(data, size) {
    let str = `
    <div class="item" data-originalFilename="${data.originalFilename}" data-fileUrl="${data.fileUrl}">
      <i class="iconfont jackery-icon-lianjie link-icon"></i>
      <span class="name">${data.originalFilename}</span>
      <span class="size">${size}</span>
      <i class="iconfont jackery-icon-a- delete-icon"></i>
    </div>
    `

    $('.J-contact-flie-list').append(str).show()
    this.delFile()
    if ($('.J-contact-flie-list').children().length >= 3) {
      $('#Contact_Media_Proposalt').parent('.btn').hide()
    } else {
      $('#Contact_Media_Proposalt').parent('.btn').show()
    }
  }
  // 删除文件
  delFile() {
    $('.J-contact-flie-list .iconfont').click(function () {
      $(this).parent('.item').remove()
      $('#Contact_Media_Proposalt').parent('.btn').show()
      if ($('.J-contact-flie-list').children().length == 0) {
        $('.J-contact-flie-list').hide()
      }
    })
  }
}

$(document).ready(function () {
  new ContactUs();
})